<template>
  <div v-if="resrchFlag === 1" id="resrch_price_area">
    <div class="resrch_product_price">
      <div class="resrch_row">商品</div>
      <div>
        <div>{{itemName}}</div>
        <div>{{formatPrice(priceData.totalTax)}}</div>
      </div>
      <div>
        <div></div>
        <div>事前現場調査後にご購入ください</div>
      </div>
    </div>
    <div v-bind:class="{resrch_price: colorType===0, resrch_price2: colorType===1}">
      <div>
        <div>事前現場調査費</div>
        <div>{{formatPrice(priceData.resrchPrice)}}</div>
      </div>
      <div>
        <div>消費税(10%)</div>
        <div>{{formatPrice(priceData.resrchPriceTax)}}</div>
      </div>
    </div>
  </div>
  <div v-bind:class="{product_price: colorType===0, product_price_net: colorType===1}" v-else>
    <table v-bind:class="{top_price_table: colorType===0, top_price_table_net: colorType===1}">
      <thead>
        <tr>
          <th class="order_th">項目</th>
          <th class="order_th">単価</th>
          <th class="order_th">数量</th>
          <th class="order_th">単位</th>
          <th class="order_th">金額</th>
        </tr>
      </thead>
      <tbody>
        <tr class="n_separator">
          <td>{{itemName}}</td>
          <td>{{formatPrice(priceData.itemDeliPrice)}}</td>
          <td>{{priceData.productCount}}</td>
          <td>台</td>
          <td>{{formatPrice(priceData.subTotalPrice)}}</td>
        </tr>
        <tr>
          <td colspan="5">（内、配送料{{formatPrice(priceData.delivaryPrice * priceData.productCount)}}を含む）</td>
        </tr>
        <tr class="n_separator">
          <td colspan="4">消費税</td>
          <td>{{formatPrice(priceData.subTotalTax)}}</td>
        </tr>
        <tr>
          <td colspan="4">商品・配送費小計（税込）</td>
          <td>{{formatPrice(priceData.subTotalPrice + priceData.subTotalTax)}}</td>
        </tr>
      </tbody>
    </table>
    <table v-bind:class="{top_price_table: colorType===0, top_price_table_net: colorType===1, tbl_space: true}" v-if="priceData.constructPrice">
      <tr class="n_separator">
        <td>組立技術料</td>
        <td>{{formatPrice(priceData.constructTotalPrice)}}</td>
        <td>1</td>
        <td>式</td>
        <td>{{formatPrice(priceData.constructTotalPrice)}}</td>
      </tr>
      <tr v-if="priceData.carryInPrice && priceData.executionVarExpensesPrice">
        <td colspan="5">（内、受け取り搬入サービス費{{formatPrice(priceData.carryInPrice * priceData.productCount)}}、諸経費{{formatPrice(priceData.executionVarExpensesPrice)}}を含む）</td>
      </tr>
      <tr v-else-if="priceData.carryInPrice && !priceData.executionVarExpensesPrice">
        <td colspan="5">（内、受け取り搬入サービス費{{formatPrice(priceData.carryInPrice * priceData.productCount)}}を含む）</td>
      </tr>
      <tr v-else-if="!priceData.carryInPrice && priceData.executionVarExpensesPrice">
        <td colspan="5">（内、諸経費{{formatPrice(priceData.executionVarExpensesPrice)}}を含む）</td>
      </tr>
      <tr class="b_separator">
        <td colspan="4">消費税</td>
        <td>{{formatPrice(priceData.constructTotalTax)}}</td>
      </tr>
      <tr>
        <td colspan="4">組立設置他サービス小計（税込）</td>
        <td>{{formatPrice(priceData.constructTotalPrice + priceData.constructTotalTax)}}</td>
      </tr>
    </table>
    <!-- ローディングモーダル -->
    <dd-loading-modal ref="loadingModalRef" />
  </div>
</template>
<script>
import LoadingModal from '../../../components/common/LoadingModal'

export default {
  name: 'DcCustomizePrice',
  components: {
    'dd-loading-modal': LoadingModal
  },
  props: {
    itemName: String,
    priceData: Object,
    profitPercent: {
      type: Number,
      default: 100
    },
    colorType: {
      type: Number,
      default: 0
    },
    resrchFlag: Number
  },
  data () {
    return {
      itemPrice: 0
    }
  },
  computed: {
  },
  methods: {
    formatPrice: function (price) {
      if (!price) return '￥0'
      let ret = String(price).replace(/(\d)(?=(\d\d\d)+(?!\d))/g, '$1,')
      return '￥' + ret
    },
    loadingOn: function () {
      this.$refs.loadingModalRef.showModal(true)
    },
    loadingOff: function () {
      this.$refs.loadingModalRef.showModal(false)
    }
  },
  watch: {
    priceData: function (price) {
      console.log('customize price watch')
      this.itemPrice = price.itemPrice
    }
  },
  mounted: function () {
  },
  created: function () {
  }
}
</script>
<style src="../../css/dctop4.scss" lang="scss" scoped></style>
<style src="../../css/dc-customize.scss" lang="scss" scoped></style>
<style src="../../css/print.scss" lang="scss" scoped></style>



// WEBPACK FOOTER //
// src/main/js/payment/components/top/DcCustomizePriceHrf.vue